import React, { Component } from 'react'
import '../styles/LandingTheme.css'
import LearnMoreButton from './LearnMoreButton'
import '../styles/Glitch.css'
import { Parallax } from 'react-scroll-parallax'
import { Link } from 'react-router-dom'
import VisibilitySensor from 'react-visibility-sensor'
import { injectIntl, defineMessages } from "react-intl"

class LandingTheme extends Component {
  handleScroll = (isVisible) => {
    if (isVisible) {
      document.getElementById(`glitch-covered-${this.props.position}`).classList.add("glitch-covered--discover")
    }
  }

  render() {
    const {intl:{formatMessage}} = this.props

    const textPosition = this.props.positionLeft ? "--left" : "--right"

    const bottleIcon = this.props.positionLeft && this.props.item2
      ? "landing-theme-icon--bottle"
      : ""

    return (
      // Remove landing-theme--hidden when Yakuza is launched
      <div className={`landing-theme landing-theme${textPosition} ${this.props.hidden ? 'landing-theme--hidden' : ''}`}>
        <Parallax
          className="landing-theme-parallax"
          offsetYMax={20}
          offsetYMin={-10}
          slowerScrollRate
          >
          <VisibilitySensor
            onChange={(isVisible) => this.handleScroll(isVisible)}
            partialVisibility
            >
            <div id={`glitch-covered-${this.props.position}`} className="glitch-covered" onClick={() => this.handleScroll()}/>
          </VisibilitySensor>
          <div className="landing-theme-picture glitch glitch--style-1">
            <div
              className="glitch__img"
              style={{backgroundImage: `url(${this.props.picture})`}}
              alt={this.props.title1}>
            </div>
            <div
              className="glitch__img"
              style={{backgroundImage: `url(${this.props.picture})`}}
              alt={this.props.title1}>
            </div>
            <div
              className="glitch__img"
              style={{backgroundImage: `url(${this.props.picture})`}}
              alt={this.props.title1}>
            </div>
            <div
              className="glitch__img"
              style={{backgroundImage: `url(${this.props.picture})`}}
              alt={this.props.title1}>
            </div>
            <div
              className="glitch__img"
              style={{backgroundImage: `url(${this.props.picture})`}}
              alt={this.props.title1}>
            </div>
          </div>
        </Parallax>
        <div className={`landing-theme-text landing-theme-text${textPosition}`}>
          <div className={`landing-theme-title landing-theme-title${textPosition}`}>
            <h2>
              {this.props.title1}<br />
              {this.props.title2}
            </h2>
            <h3>{this.props.baseline}</h3>
            <p>{this.props.description}</p>
            <Link to={this.props.path}>
              <LearnMoreButton
                text={formatMessage(messages.learnMore)}
                styleClass="learn-more-theme"
                glitch />
            </Link>
          </div>
        </div>
        <Parallax
          className="landing-theme-icon-parallax"
          offsetYMax={"5px"}
          offsetYMin={"-70px"}
          slowerScrollRate
          >
          {this.props.item1
            ?
            <img
              className="landing-theme-icon landing-theme-icon--1"
              src={this.props.item1}
              alt="Escape game à Paris" />
            : null
          }
          {this.props.item2
            ?
            <img
              className={`landing-theme-icon landing-theme-icon--2 ${bottleIcon}`}
              src={this.props.item2}
              alt="Escape room à Paris" />
            : null
          }
        </Parallax>
      </div>
    );
  }
}

export default injectIntl(LandingTheme)

const messages = defineMessages({
  learnMore: {
    id: 'landingTheme.learnMore',
    defaultMessage: 'En savoir plus'
  }
})



// WEBPACK FOOTER //
// ./src/components/LandingTheme.js